import { render, staticRenderFns } from "./broadcast-notice.vue?vue&type=template&id=44d89886"
import script from "./broadcast-notice.vue?vue&type=script&lang=js"
export * from "./broadcast-notice.vue?vue&type=script&lang=js"
import style0 from "./broadcast-notice.vue?vue&type=style&index=0&id=44d89886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports